/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-dcf624da.mjs';
import { _ as _defineProperty } from '../_chunks/dep-0b4c3c44.mjs';
import { defineComponent, ref, computed, toRefs, onMounted, onBeforeUnmount, createVNode, Fragment, Teleport } from 'vue';
import { ChevronDownIcon, ChevronLeftIcon, CloseIcon } from 'tdesign-icons-vue-next';
import props from './props.mjs';
import TImageViewerIcon from './base/ImageModalIcon.mjs';
import TImageViewerUtils from './base/ImageViewerUtils.mjs';
import TImageItem from './base/ImageItem.mjs';
import TImageViewerModal from './base/ImageViewerModal.mjs';
import { useTNodeJSX } from '../hooks/tnode.mjs';
import useVModel from '../hooks/useVModel.mjs';
import useDefaultValue from '../hooks/useDefaultValue.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import { useMirror, useScale, useRotate } from './hooks.mjs';
import { getOverlay, formatImages } from './utils.mjs';
import { EVENT_CODE } from './const.mjs';
import '../_chunks/dep-556a2f2c.mjs';
import '../tooltip/index.mjs';
import '../tooltip/tooltip.mjs';
import '../_chunks/dep-0b4185fe.mjs';
import '../_chunks/dep-a48de419.mjs';
import '../_chunks/dep-3ca5fb38.mjs';
import '../_chunks/dep-7071345f.mjs';
import '../_chunks/dep-d2403b2f.mjs';
import '../tooltip/props.mjs';
import '../popup/props.mjs';
import '../popup/index.mjs';
import '../popup/popup.mjs';
import '@popperjs/core';
import '../utils/dom.mjs';
import '../_chunks/dep-2684fd15.mjs';
import '../_chunks/dep-3d4aad09.mjs';
import '../_chunks/dep-c27b1c14.mjs';
import '../utils/easing.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-40522c7c.mjs';
import '../_chunks/dep-83862ee1.mjs';
import '../_chunks/dep-f6b25712.mjs';
import '../_chunks/dep-59545a4d.mjs';
import '../_chunks/dep-7d96367f.mjs';
import '../_chunks/dep-4889eb51.mjs';
import '../_chunks/dep-7922050a.mjs';
import '../_chunks/dep-caad2e91.mjs';
import '../_chunks/dep-469bf54b.mjs';
import '../_chunks/dep-8e451077.mjs';
import '../_chunks/dep-a82b01df.mjs';
import '../_chunks/dep-192e10f1.mjs';
import '../_chunks/dep-977c5cdd.mjs';
import '../_chunks/dep-755716aa.mjs';
import '../_chunks/dep-82798823.mjs';
import '../_chunks/dep-52cbb58a.mjs';
import '../_chunks/dep-db11154e.mjs';
import '../_chunks/dep-baa4f9dc.mjs';
import '../_common/js/utils/set-style.mjs';
import '../popup/container.mjs';
import '../_chunks/dep-8c39d78a.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../popup/type.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-bfb23a5e.mjs';
import '../_chunks/dep-2a7dc5c7.mjs';
import '../_chunks/dep-9311bf66.mjs';
import '../_chunks/dep-169ea640.mjs';
import '../_chunks/dep-827c4600.mjs';
import '../_chunks/dep-0820e0e2.mjs';
import '../_chunks/dep-8e38f523.mjs';
import '../_chunks/dep-8ef9fb8e.mjs';
import '../_chunks/dep-e769aafd.mjs';
import '../_chunks/dep-400798c5.mjs';
import '../_chunks/dep-361522ee.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../config-provider/type.mjs';
import '../tooltip/util.mjs';
import '../tooltip/type.mjs';
import '../dialog/index.mjs';
import '../dialog/dialog.mjs';
import '../dialog/props.mjs';
import '../utils/transfer-dom.mjs';
import '../hooks/useGlobalIcon.mjs';
import '../dialog/hooks.mjs';
import '../button/index.mjs';
import '../button/button.mjs';
import '../loading/index.mjs';
import '../loading/directive.mjs';
import '../loading/plugin.mjs';
import '../loading/loading.mjs';
import '../loading/icon/gradient.mjs';
import '../_common/js/loading/circle-adapter.mjs';
import '../_common/js/utils/helper.mjs';
import '../_chunks/dep-e68fd68c.mjs';
import '../loading/props.mjs';
import '../loading/type.mjs';
import '../button/props.mjs';
import '../hooks/useRipple.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../utils/set-style.mjs';
import '../form/hooks.mjs';
import '../button/type.mjs';
import '../hooks/useDestroyOnClose.mjs';
import '../dialog/stack.mjs';
import '../dialog/type.mjs';
import '../dialog/plugin.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _ImageViewer = defineComponent({
  name: "TImageViewer",
  props: _objectSpread({}, props),
  setup: function setup(props2) {
    var _props2$defaultIndex;

    var classPrefix = usePrefixClass();
    var COMPONENT_NAME = usePrefixClass("image-viewer");
    var renderTNodeJSX = useTNodeJSX();
    var isExpand = ref(false);
    var showOverlayValue = computed(function () {
      return getOverlay(props2);
    });
    var wrapClass = computed(function () {
      return ["".concat(COMPONENT_NAME.value, "-preview-image"), _defineProperty({}, "".concat(classPrefix.value, "-is-hide"), !props2.visible)];
    });
    var headerClass = computed(function () {
      return ["".concat(classPrefix.value, "-image-viewer__modal-header"), _defineProperty({}, "".concat(classPrefix.value, "-is-show"), isExpand.value)];
    });
    var zIndexValue = computed(function () {
      var _props2$zIndex;

      return (_props2$zIndex = props2.zIndex) !== null && _props2$zIndex !== void 0 ? _props2$zIndex : 2e3;
    });

    var toggleExpand = function toggleExpand() {
      isExpand.value = !isExpand.value;
    };

    var _useMirror = useMirror(),
        mirror = _useMirror.mirror,
        onMirror = _useMirror.onMirror,
        resetMirror = _useMirror.resetMirror;

    var _useScale = useScale(props2.imageScale),
        scale = _useScale.scale,
        onZoomIn = _useScale.onZoomIn,
        onZoomOut = _useScale.onZoomOut,
        resetScale = _useScale.resetScale;

    var _useRotate = useRotate(),
        rotate = _useRotate.rotate,
        onRotate = _useRotate.onRotate,
        resetRotate = _useRotate.resetRotate;

    var onRest = function onRest() {
      resetMirror();
      resetScale();
      resetRotate();
    };

    var images = computed(function () {
      return formatImages(props2.images);
    });

    var _toRefs = toRefs(props2),
        index = _toRefs.index,
        visible = _toRefs.visible,
        modelValue = _toRefs.modelValue;

    var _useDefaultValue = useDefaultValue(index, (_props2$defaultIndex = props2.defaultIndex) !== null && _props2$defaultIndex !== void 0 ? _props2$defaultIndex : 0, props2.onIndexChange, "index"),
        _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
        indexValue = _useDefaultValue2[0],
        setIndexValue = _useDefaultValue2[1];

    var currentImage = computed(function () {
      var _images$value$indexVa;

      return (_images$value$indexVa = images.value[indexValue.value]) !== null && _images$value$indexVa !== void 0 ? _images$value$indexVa : {
        mainImage: ""
      };
    });

    var prevImage = function prevImage() {
      var newIndex = indexValue.value - 1;
      setIndexValue(newIndex < 0 ? 0 : newIndex, {
        trigger: "prev"
      });
    };

    var nextImage = function nextImage() {
      var newIndex = indexValue.value + 1;
      setIndexValue(newIndex >= images.value.length ? indexValue.value : newIndex, {
        trigger: "next"
      });
    };

    var onImgClick = function onImgClick(i) {
      setIndexValue(i);
    };

    var _useVModel = useVModel(visible, modelValue, props2.defaultVisible, function () {}, "visible"),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        visibleValue = _useVModel2[0],
        setVisibleValue = _useVModel2[1];

    var onClose = function onClose(ctx) {
      var _props2$onClose;

      setVisibleValue(false, ctx);
      (_props2$onClose = props2.onClose) === null || _props2$onClose === void 0 ? void 0 : _props2$onClose.call(props2, ctx);
    };

    var closeBtnAction = function closeBtnAction(e) {
      onClose({
        e: e,
        trigger: "close-btn"
      });
    };

    var clickOverlayHandler = function clickOverlayHandler(e) {
      if (props2.closeOnOverlay) {
        onClose({
          e: e,
          trigger: "overlay"
        });
      }
    };

    var keydownHandler = function keydownHandler(e) {
      switch (e.code) {
        case EVENT_CODE.left:
          prevImage();
          break;

        case EVENT_CODE.right:
          nextImage();
          break;

        case EVENT_CODE.up:
          onZoomIn();
          break;

        case EVENT_CODE.down:
          onZoomOut();
          break;

        case EVENT_CODE.esc:
          onClose({
            e: e,
            trigger: "esc"
          });
          break;

        default:
          break;
      }
    };

    onMounted(function () {
      window.addEventListener("keydown", keydownHandler);
    });
    onBeforeUnmount(function () {
      window.removeEventListener("keydown", keydownHandler);
    });

    var onWheel = function onWheel(e) {
      e.preventDefault();
      var deltaY = e.deltaY,
          ctrlKey = e.ctrlKey;

      if (ctrlKey) {
        return deltaY > 0 ? onZoomOut() : onZoomIn();
      }

      deltaY > 0 ? onZoomIn() : onZoomOut();
    };

    var transStyle = computed(function () {
      return {
        transform: "translateX(-".concat(indexValue.value * 84, "px)")
      };
    });

    var renderHeader = function renderHeader() {
      return createVNode("div", {
        "class": headerClass.value
      }, [createVNode(TImageViewerIcon, {
        "icon": function icon() {
          return createVNode(ChevronDownIcon, {
            "size": "20px"
          }, null);
        },
        "class": "".concat(COMPONENT_NAME.value, "__header--pre__bt"),
        "onClick": toggleExpand
      }, null), createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "__header--prev")
      }, [createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "__bokeh--left")
      }, null), createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "__bokeh--right")
      }, null), createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "__header--trans"),
        "style": transStyle.value
      }, [images.value.map(function (image, index2) {
        return createVNode("div", {
          "key": index2,
          "class": ["".concat(COMPONENT_NAME.value, "__header--box"), _defineProperty({}, "".concat(classPrefix.value, "-is-active"), index2 === indexValue.value)]
        }, [createVNode("img", {
          "alt": "",
          "src": image.thumbnail || image.mainImage,
          "className": "".concat(COMPONENT_NAME.value, "__header--img"),
          "onClick": function onClick() {
            return onImgClick(index2);
          }
        }, null)]);
      })])])]);
    };

    var renderNavigationArrow = function renderNavigationArrow(type) {
      var rotateDeg = type === "prev" ? 0 : 180;

      var _icon = renderTNodeJSX("navigationArrow", createVNode(ChevronLeftIcon, {
        "style": {
          transform: "rotate(".concat(rotateDeg, "deg)")
        },
        "size": "24px"
      }, null));

      return createVNode(TImageViewerIcon, {
        "class": "".concat(COMPONENT_NAME.value, "__modal--").concat(type, "-bt"),
        "onClick": type === "prev" ? prevImage : nextImage,
        "icon": function icon() {
          return _icon;
        }
      }, null);
    };

    return function () {
      if (props2.mode === "modeless") {
        return createVNode(Fragment, null, [renderTNodeJSX("trigger"), createVNode(TImageViewerModal, {
          "zIndex": zIndexValue.value,
          "visible": visibleValue.value,
          "index": indexValue.value,
          "images": images.value,
          "scale": scale.value,
          "rotate": rotate.value,
          "mirror": mirror.value,
          "currentImage": currentImage.value,
          "onRotate": onRotate,
          "onZoomIn": onZoomIn,
          "onZoomOut": onZoomOut,
          "onMirror": onMirror,
          "onReset": onRest,
          "onClose": onClose,
          "draggable": props2.draggable,
          "showOverlay": showOverlayValue.value,
          "closeBtn": props2.closeBtn
        }, null)]);
      }

      return createVNode(Fragment, null, [renderTNodeJSX("trigger"), createVNode(Teleport, {
        "to": "body"
      }, {
        "default": function _default() {
          return [visibleValue.value && createVNode("div", {
            "class": wrapClass.value,
            "style": {
              zIndex: zIndexValue.value
            },
            "onWheel": onWheel
          }, [!!showOverlayValue.value && createVNode("div", {
            "class": "".concat(COMPONENT_NAME.value, "__modal--mask"),
            "onClick": clickOverlayHandler
          }, null), createVNode(TImageViewerModal, null, null), images.value.length > 1 && createVNode(Fragment, null, [renderHeader(), createVNode("div", {
            "class": "".concat(COMPONENT_NAME.value, "__modal--index")
          }, ["".concat(indexValue.value + 1, "/").concat(images.value.length)]), renderNavigationArrow("prev"), renderNavigationArrow("next")]), createVNode("div", {
            "class": ["".concat(COMPONENT_NAME.value, "__modal--icon"), "".concat(COMPONENT_NAME.value, "__modal--close-bt")],
            "onClick": closeBtnAction
          }, [renderTNodeJSX("closeBtn", createVNode(CloseIcon, {
            "size": "24px"
          }, null))]), createVNode(TImageViewerUtils, {
            "onZoomIn": onZoomIn,
            "onZoomOut": onZoomOut,
            "onMirror": onMirror,
            "onReset": onRest,
            "onRotate": onRotate,
            "scale": scale.value,
            "currentImage": currentImage.value
          }, null), createVNode(TImageItem, {
            "scale": scale.value,
            "rotate": rotate.value,
            "mirror": mirror.value,
            "src": currentImage.value.mainImage,
            "placementSrc": currentImage.value.thumbnail
          }, null)])];
        }
      })]);
    };
  }
});

export { _ImageViewer as default };
//# sourceMappingURL=image-viewer.mjs.map
